/**
 * Vendored from lightvue@1.5.1/mixins
 * Only the two mixins actually used in this project.
 */

export const trueValueMixin = {
  props: ['value'],
  emits: ['input', 'update:modelValue'],
  computed: {
    modelValue() {
      return this.$attrs.modelValue ? this.$attrs.modelValue : this.value
    },
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val)
      this.$emit('update:modelValue', val)
    },
  },
}

export const preventBrowserBackMixin = {
  data() {
    return { popstateEvent: null }
  },
  methods: {
    preventPopstate() {
      window.history.pushState({ id: 2 }, null, null)
      window.addEventListener('popstate', this.handleOnPopstate)
      this.popstateEvent = true
    },
    handleOnPopstate() {
      window.removeEventListener('popstate', null)
      this.popstateEvent = null
      if (this.handleOnBrowserBack) {
        this.handleOnBrowserBack()
      }
    },
    manuallyClosePopstate() {
      if (this.popstateEvent) {
        if (this.$router) {
          this.$router.go(-1)
        }
        window.removeEventListener('popstate', null)
        this.popstateEvent = null
      }
    },
  },
}
